import { useCallback } from "react";

export interface ObservableErrorContext {
  route: string;
  stage: string;
  extra?: Record<string, unknown>;
}

/**
 * Centralized error capture hook.
 * Uses dynamic import to preserve nLPD consent-gate (Sentry init is lazy in main.tsx).
 * In DEV: also logs to console.warn for visibility.
 * In PROD: only sends to Sentry if DSN is configured and consent granted.
 */
export function useObservableError() {
  return useCallback((error: unknown, context: ObservableErrorContext) => {
    const err = error instanceof Error ? error : new Error(String(error));

    if (import.meta.env.VITE_SENTRY_DSN) {
      void import("@sentry/react")
        .then((Sentry) =>
          Sentry.captureException(err, {
            tags: { route: context.route, stage: context.stage },
            extra: context.extra,
          }),
        )
        .catch(() => {});
    }

    if (import.meta.env.DEV) {
      console.warn(`[${context.route}:${context.stage}]`, error);
    }
  }, []);
}
